import axios from 'axios';
import account from '@/api/v1/account';

import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home/Index';

import Login from '@/views/Auth/Login';
import TeacherLogin from '@/views/Auth/TeacherLogin';
import Registration from '@/views/Auth/Registration';
import EmailConfirmation from '@/views/Auth/EmailConfirmation';
import UserDeactivated from '@/views/Auth/UserDeactivated';

import StudentList from '@/views/StudentList/Index';

import Settings from '@/views/Pages/Settings';
import Impressum from '@/views/Pages/Impressum';
import Faq from '@/views/Pages/Faq';

import NewMessage from '@/components/Messages/New/Index';
import AddReceivers from '@/components/Messages/New/Receivers';

import ShowMessage from '@/components/Messages/Show/Index';
import ShowMessageConfirmations from '@/components/Messages/Show/Confirmations';
import ShowMessageResponds from '@/components/Messages/Show/Responds';
import ShowPollResult from '@/components/Messages/Show/PollResult';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        {
          path: 'new_message',
          name: 'new_message',
          component: NewMessage,
        },
        {
          path: 'new_message/add_receivers',
          name: 'add_receivers',
          component: AddReceivers,
        },
        {
          path: 'show_message/:id(\\d+)',
          name: 'show_message',
          component: ShowMessage,
        },
        {
          path: 'show_message/:id(\\d+)/confirmations',
          name: 'confirmations',
          component: ShowMessageConfirmations,
        },
        {
          path: 'show_message/:id(\\d+)/responds',
          name: 'responds',
          component: ShowMessageResponds,
        },
        {
          path: 'show_message/:id(\\d+)/result',
          name: 'poll_result',
          component: ShowPollResult,
        },
      ],
    },
    {
      path: '/student-list',
      name: 'student-list',
      component: StudentList,
      meta: { teacher: true },
    },
    // Auth
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { public: true },
    },
    {
      path: '/teacher_login',
      name: 'teacher_login',
      component: TeacherLogin,
      meta: { public: true },
    },
    {
      path: '/registration',
      name: 'registration',
      component: Registration,
      meta: { public: true },
    },
    {
      path: '/email_confirmation',
      name: 'email_confirmation',
      component: EmailConfirmation,
      meta: { protected: true },
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: Impressum,
    },
    {
      path: '/deactivated',
      name: 'user_deactivated',
      component: UserDeactivated,
    },
    // TODO add 404 page template
    {
      path: '*',
      component: Home,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Set pinboard id on route enter
  if (to.query.pinboardid && to.query.pinboardid !== localStorage.getItem('Pinboard-Id')) {
    localStorage.setItem('Pinboard-Id', to.query.pinboardid);
    location.href = '';
  }
  // Check if entered route needs authentication, then check if user is logged in
  if (!to.matched.some(record => record.meta.public)) {
    const user = account.user;
    const canAccess = user.isParent() ? (user.isAuthenticated() && user.isConfirmed()) : user.isAuthenticated();
    // if route is protected, user has to be authenticated, but does not have to be confirmed
    if (to.matched.some(record => record.meta.protected)) {
      if (!user.authenticated) {
        next({
          name: 'login',
          query: { redirect: to.fullPath },
        });
      } else next();
    // if route is not protected, check if user can access private page
    } else if (!canAccess) {
      next({
        name: 'login',
        query: { redirect: to.fullPath },
      });
    // if route is only for teacher, check user's role
    } else if (to.matched.some(record => record.meta.teacher) && user.isParent()) {
      next({ name: 'home' });
    } else next();
  // if user is authorized to visit a page navigate to entered route
  } else {
    next();
  }
});

axios.interceptors.response.use((response) => {
  if (response.data.statuscode === 20 && account.user.authenticated) {
    account.logout();
  }
  return response;
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js